<template>
    <div>
        <ValidationObserver ref="formModalValidate">
                <b-row>
                    <b-col cols="12">
                        <ValidationProvider name="program_code" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('program')">
                                <program-selectbox v-model="form.program_code" :validate-error="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12">
                            <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('semesters')">
                                    <semesters-selectbox v-model="form.semester_id"
                                                         :setActive="true" :validate-error="errors[0]">
                                    </semesters-selectbox>
                                </b-form-group>
                            </ValidationProvider>
                    </b-col>
                    <b-col cols="12">
                        <ValidationProvider name="expected_count" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('expected_count')">
                                <b-form-input type="number" v-model="form.expected_count" :state="errors[0] ? false : null"/>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </ValidationObserver>
            <div class="col-12 mt-3 d-flex">
                <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                    {{ $t("save").toUpperCase() }}
                </b-button>
            </div>
    </div>
</template>

<script>
    //Component
    import StateSelectbox from "@/components/interactive-fields/StateSelectbox";
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import ProjectedEnrollmentService from "@/services/ProjectedEnrollmentService";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            StateSelectbox
        },
        data() {
            return {
                formLoading: false,
                form: {
                    program_code: null,
                    semester_id: null,
                    expected_count: null,
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    ProjectedEnrollmentService.store(this.form)
                                   .then((response) => {
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("createFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   });
                }
            }
        }
    }
</script>
